module.exports = __webpack_public_path__ + "europa-50_front.jpg?bcb63c5a8f065810226dbfb9dbdd5bfc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-50_front.jpg
// module id = 373
// module chunks = 0